import React from 'react';
import './conversation-errors.scss';
import { ConversationErrorType } from './conversationErrors';
import { ReactComponent as ExclamationCircleIcon } from '../../../../icons/error-exclamation-circle.svg';

interface ConversationsLoadingErrorProps {
  errorMessage: string;
  errorType: ConversationErrorType;
  onRetry?: () => void;
}

const ConversationsLoadingError: React.FC<ConversationsLoadingErrorProps> = ({
  errorMessage,
  errorType,
  onRetry,
}) => {
  // Get appropriate error message based on error type
  const getErrorMessage = () => {
    switch (errorType) {
      case ConversationErrorType.UNSUCCESSFUL:
        return "We couldn't load your conversations. The server reported an issue.";
      case ConversationErrorType.POSSIBLE_NETWORK_ERROR:
        return 'There may be a problem with your internet connection.';
      case ConversationErrorType.UNKNOWN:
      default:
        return "We couldn't load your conversations right now.";
    }
  };

  return (
    <div className='chat-sidebar-error'>
      <div className='error-icon'>
        <ExclamationCircleIcon />
      </div>
      <div className='error-details'>
        <div className='chat-error-message'>{getErrorMessage()}</div>
        <div className='chat-error-message'>
          {errorMessage && errorType !== ConversationErrorType.UNSUCCESSFUL && (
            <span className='error-details-text'>{errorMessage}</span>
          )}
        </div>
      </div>
      {onRetry && (
        <button className='retry-button' onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
};

export default ConversationsLoadingError;
